module.exports = __webpack_public_path__ + "fonts/eca1317.otf";